import React from 'react';
import Sidebar from '../../views/common/Sidebar';
import profileBg from '../../images/patterns/profilebg.png';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import sidebar_props from '../../model/AppConstants';
import ComponentRegistry from '../../model/ComponentRegistry';

let prep_menus = sidebar_props.prep_menus;

export default class prep_sidebar extends Sidebar{

 	constructor(props) {
         super(props);
         this.renderSidebarTab=this.renderSidebarTab.bind(this);
     }
     
     componentDidMount(){
		console.log("prep_sidebar");
         super.componentDidMount();
	 }

	 renderHumburger(){
		return (
			<div className="showhidemenu">
			    	<a id="toggle-btn" href="#" className="menu-btn active" onClick={this.showHideLeftMenu}>
			    		<i className="material-icons">menu</i>
			    	</a>
			    </div>	
		)
	}
	 
	 getSideBarMenus(){
		var me = this;
		let elements = prep_menus.map((element,index) => {       
		  return (<li key={index} className={me.rb(element.label)+" leftmenu "+(parseInt(this.state.selectedID) === parseInt(element.id) ? "active" : "")} onClick={this.leftmenuclick.bind(this)} data-id={element.id} data-value={element.value}><a> <i className="material-icons">{element.materialkey}</i> <span className="leftmenutxt">{me.rb(element.label)}</span> </a></li>)
		})
		return elements;
	  
	}

	renderSidebarTab(){
		var me=this;
		return (
			<ul className="list-unstyled">	
			{( ()=> {
				if(me.comboNamesLoaded){
					return (
						<div>
						{me.getGradeMenus()}
						{/* {me.getProductMenus()} */}
					{/* {me.getMenusFromJson()} */}
					</div>
					);	
				}

			})()}

			{/* {me.getSideBarMenus()} */}
			</ul>
			)
				}
     
    render() {
        return super.render()
    }
}

ComponentRegistry.register("prep_sidebar",prep_sidebar);

/*
* Also registering for the users with hm_ prefix
*/
//ComponentRegistry.register("hm_sidebar",prep_sidebar);


// WEBPACK FOOTER //
// ./src/vendors/prep/prep_sidebar.js